import { store } from "../redux/store";
import { saveForm } from "./formsSlice";

export const createDismissCustomErrorHandler = (formName: string, fieldName: string) => {
  return () => {
    store.dispatch(
      saveForm({
        formName,
        formState: {
          [fieldName]: {
            showCustomError: false,
          },
        },
      })
    );
  };
};
